module.exports = __webpack_public_path__ + "static/details-7-903e132ae1217859ac0de327ce9393cf.jpg";